import Router from '@utils/router'

new Router([
	{ file: 'pages/main' },

	{
		file: 'pages/listing',
		resolve: '.listing-container'
	},

	{
		file: 'blocks/video',
		resolve: '.video'
	},

	{
		file: 'blocks/swiper-solutions',
		resolve: '.solutions'
	},

	{
		file: 'blocks/swiper-content',
		resolve: '.swiper-content'
	},

	{
		file: 'blocks/range',
		resolve: '.range'
	},

	{
		file: 'blocks/scrolling-banner',
		resolve: '.scrolling-banner'
	},

	{
		file: 'blocks/features',
		resolve: '.features'
	},

	{
		file: 'blocks/hero',
		resolve: 'header'
	},

	{
		file: 'blocks/form',
		resolve: 'form'
	},

	{
		file: 'blocks/language',
		resolve: '.language'
	}
]).load()